import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { PbZonenData, PbZonenActions } from '../../../providers/pbzonen-data';
import { UserData } from '../../../providers/user-data';

/**
 * Generated class for the PbactionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pbzonenactions',
  templateUrl: 'pbzonenactions.html',
})
export class PbZonenactionsPage  implements OnInit {
  public pbZonenActions = PbZonenActions;
  constructor(public navCtrl: NavController

            , public zonenData: PbZonenData
            , private _viewController: ViewController
            , private userData: UserData
    ) 
  {

  }

  ionViewDidLoad() {
    
  }
  ngOnInit(){
    this.zonenData.selectedZonenAction = PbZonenActions.None;
  }
  selectAction(action: PbZonenActions){
    this.zonenData.selectedZonenAction = action;
    this._viewController.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbzonenactions/pbzonenactions.ts